import { render, staticRenderFns } from "./InventoryTable.vue?vue&type=template&id=b6a8bb00&scoped=true&"
import script from "./InventoryTable.vue?vue&type=script&lang=js&"
export * from "./InventoryTable.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTable.vue?vue&type=style&index=0&id=b6a8bb00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a8bb00",
  null
  
)

export default component.exports